"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classnames = _interopRequireDefault(require("classnames"));

var BoxWidget = function BoxWidget(_ref) {
  var className = _ref.className,
      contentClassName = _ref.contentClassName,
      children = _ref.children;
  return (0, _preact.h)("div", {
    className: (0, _classnames.default)('box', 'widget', className)
  }, (0, _preact.h)("div", {
    className: (0, _classnames.default)('box__content', 'box__pad', contentClassName)
  }, children));
};

var _default = BoxWidget;
exports.default = _default;